/** @jsxImportSource @emotion/react */
import { SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';
import { DivProps } from 'typings';
import { theme } from 'styles/theme/theme';

interface IProps extends React.PropsWithChildren<DivProps> {
  headerProps?: DivProps;
  contentProps?: { css?: SerializedStyles } & DivProps;
  title?: string;
}

function ListContainer(props: IProps) {
  const { title, headerProps, contentProps, children, ...rest } = props;

  return (
    <MainBlock {...rest}>
      <Header {...headerProps}>{title}</Header>
      <Content {...contentProps}>{children}</Content>
    </MainBlock>
  );
}

export default ListContainer;

const MainBlock = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
`;

const Header = styled.div`
  padding: 8px;
  gap: 10px;
  border-radius: 8px 8px 0 0;
  background: ${theme.colors.SurfaceIndependence40};

  font-family:
    SF Pro Text,
    sans-serif;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  color: white;
`;

const Content = styled.div`
  border-radius: 0 0 8px 8px;
  background: ${theme.colors.SurfaceWhite};
  flex-grow: 1;

  &::-webkit-scrollbar {
    width: 7px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #cbcbcb;
    border-radius: 8px;
  }
`;
